import { smibConstants } from './smibConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function smibs(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case smibConstants.SMIB_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case smibConstants.SMIB_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.smibs.rows ? action.smibs.rows : [],
        total: action.smibs.total ? action.smibs.total : 0,
        inProgress: false,
      };
    case smibConstants.SMIB_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case smibConstants.SMIB_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case smibConstants.SMIB_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.exactValues !== action.pagination.exactValues
        || state.exactFields !== action.pagination.exactFields
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        exactValues: action.pagination.exactValues,
        exactFields: action.pagination.exactFields,
        shouldReload
      };
    }

    case smibConstants.SMIB_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case smibConstants.SMIB_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.smib]
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(s => s.id === action.smib.id ? action.smib : s)
      }
    case smibConstants.SMIB_DONE_SUCCESS:
      return {
        ...state,
        requestSaveActive: false
      }
    case smibConstants.SMIB_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }


    default:
      return state
  }
}
